import React from "react"
import classnames from "classnames"
import componentParser from "AtomicUtils/componentParser"
import styles from "./ButtonGroup.less"

class ButtonGroup extends React.PureComponent {
  render() {
    const {
      components,
      children,
      alignment = "center",
      stacked = false
    } = this.props
    return (
      <div
        className={classnames({
          [styles.ButtonGroup]: true,
          [styles.ButtonGroupStacked]: stacked,
          [styles.ButtonGroupCenter]: alignment === "center",
          [styles.ButtonGroupRight]: alignment === "right",
          [styles.ButtonGroupLeft]: alignment === "left"
        })}
      >
        {componentParser(components) || children}
      </div>
    )
  }
}

export default ButtonGroup



// WEBPACK FOOTER //
// ./src/AtomicComponents/ButtonGroup/ButtonGroup.jsx